import monthlyData from "./index_data_monthly.json";
import weeklyData from "./index_data_weekly.json";
import {
    IndexData,
    IndexEntry,
    MMDDYYYYStringToDate,
} from "../utils";

export { monthlyData as indexDataMonthlyLegacy, weeklyData as indexDataWeeklyLegacy };

function transformWeeklyToMonthly(data: IndexData[]) {
    const startingDate = data[0].date;
    const startingMonthStart = new Date(startingDate.getFullYear(), startingDate.getMonth(), 1);
    const endingDate = new Date(data[data.length - 1].date);

    const monthlyData: IndexData[] = [];
    var idx = 0;
    for (let monthStart = startingMonthStart; monthStart <= endingDate; monthStart.setMonth(monthStart.getMonth() + 1)) {
        const monthEnd = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0);
        // Start at idx.  
        var current_entries: IndexEntry[] = [];
        while (idx < data.length && new Date(data[idx].date) <= monthEnd) {
            if (current_entries.length == 0) {
                current_entries.push(
                    ...data[idx].index_entries.map(entry => {
                        return {
                            ...entry,
                        }
                    }
                    )
                )
            } else {
                data[idx].index_entries.forEach((entry) => {
                    var current_entry = current_entries.find(e => e.index_type === entry.index_type);
                    if (current_entry) {
                        current_entry.index_value = entry.index_value;
                        if (current_entry.volume && entry.volume) {
                            current_entry.volume += entry.volume;
                        }
                    } else {
                        current_entries.push({
                            index_type: entry.index_type,
                            index_value: entry.index_value,
                            volume: entry.volume
                        });
                    }
                }
                )
            }
            idx++;
        }
        monthlyData.push({
            date: monthEnd,
            index_entries: current_entries
        });
    }
    const finalMonthEnd = new Date(endingDate.getFullYear(), endingDate.getMonth() + 1, 0);
    const finalDaysUntilMonthEnd = (finalMonthEnd.getTime() - endingDate.getTime()) / (1000 * 3600 * 24);
    // Set volume of last entries to Null unless the final date is <= 7 days of the months end
    if (finalDaysUntilMonthEnd > 7) {
        monthlyData[monthlyData.length - 1].index_entries.forEach(
            entry => { entry.volume = null }
        )
        monthlyData[monthlyData.length - 1].date = endingDate;
    }
    return monthlyData;
}

export async function getIndexData(): Promise<{ weeklyData: IndexData[] | undefined, monthlyData: IndexData[] | undefined }> {
    if (process.env.GATSBY_INDEX_DATA_WEEKLY_URL != undefined) {
        // Await and catch errors
        try {
            let response = await fetch(process.env.GATSBY_INDEX_DATA_WEEKLY_URL);
            let data = await response.json();
            let tempWeeklyData = data.map((entry: { date: string; index_entries: IndexEntry[]; }) => ({
                date: MMDDYYYYStringToDate(entry.date),
                index_entries: entry.index_entries,
            }));
            return {
                weeklyData: tempWeeklyData,
                monthlyData: transformWeeklyToMonthly(tempWeeklyData),
            };
        } catch (error) {
            console.error(error);
        }
    }
    return {
        weeklyData: undefined,
        monthlyData: undefined,
    }
}
